// Distress Signal (design doc 16.54, LOCKED interview pass): "25% chance
// per check, re-rolled every 2 real-clock minutes... until one succeeds,"
// 3-5x fuel-price markup once it does. A rescue mechanic for a ship
// stranded with insufficient fuel to Fast Travel/Warp anywhere.
export const DISTRESS_CHECK_CHANCE = 0.25;
export const DISTRESS_CHECK_INTERVAL_MS = 2 * 60 * 1000;
export const DISTRESS_MARKUP_MIN = 3;
export const DISTRESS_MARKUP_MAX = 5;

export interface DistressSignalState {
  active: boolean;
  nextCheckAt: number | null; // effectiveNow-based epoch ms
  markup: number | null; // rolled once a check succeeds; null while still waiting
}

export function activateDistressSignal(nowEffective: number): DistressSignalState {
  return { active: true, nextCheckAt: nowEffective + DISTRESS_CHECK_INTERVAL_MS, markup: null };
}

export function cancelDistressSignal(): DistressSignalState {
  return { active: false, nextCheckAt: null, markup: null };
}

// Re-rolls the 25% check once `nextCheckAt` has passed -- on failure,
// simply reschedules the next check 2 minutes out (per 16.54, re-rolled
// "until one succeeds"); on success, rolls a real 3-5x markup and stops
// re-rolling (the offer stands until fulfilled or cancelled). A no-op,
// returning the same reference, if the check isn't due yet or the offer
// already succeeded -- callers can call this unconditionally every frame.
export function tickDistressSignal(signal: DistressSignalState, nowEffective: number, roll = Math.random): DistressSignalState {
  if (!signal.active || signal.markup !== null || signal.nextCheckAt === null || nowEffective < signal.nextCheckAt) {
    return signal;
  }
  if (roll() < DISTRESS_CHECK_CHANCE) {
    const markup = DISTRESS_MARKUP_MIN + roll() * (DISTRESS_MARKUP_MAX - DISTRESS_MARKUP_MIN);
    return { ...signal, markup };
  }
  return { ...signal, nextCheckAt: nowEffective + DISTRESS_CHECK_INTERVAL_MS };
}
